import { authRequest } from './index.js'

export async function create_child(formData){
  let data
  let reports_data =  formData.reports
  let child_meta_data =  formData.temp_meta
  formData['reports_attributes'] = reports_data
  formData['child_meta_attributes'] = child_meta_data
  
  await authRequest.post(
    '/children', 
    {children: formData}, 
    { headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function update_report(formData){
  let data
  let report = {
    sample_id: formData.temp_sample_id,
    id: formData.id
  }
  // delete formData['reports']
  await authRequest.patch(
    '/report/' + report.id, 
    {report}, 
    { headers: {
        'Content-Type': 'application/json'
      }
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function retrieve_children(params = '?reports=true'){
  let data
  await authRequest.get(
    '/childrens' + params
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function retrieve_child(id, params = '?reports=true&meta=true'){
  let data
  await authRequest.get(
    '/children/' + id + params
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function retrieve_child_meta(id){
  let data
  await authRequest.get(
    '/children/' + id + '/meta'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function show_trait_count(id){
  let data
  await authRequest.get(
    '/children/' + id + '/trait_count'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_report_stats(report_id){
  let data
  await authRequest.get(
    '/report/' + report_id + '/meta'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_file(id){
  let data
  await authRequest.get(
    '/report/' + id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function send_request(id, trait_id){
  let data
  await authRequest.post(
    '/children/' + id + '/request_level_up',
    {children: {trait_id}}
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function filterChildren(filterObj){
  let data
  await authRequest.get(
    '/childrens',
    {
      params: filterObj
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function delete_child(child_id){
  let data
  await authRequest.delete(
    '/children/' + child_id,
    { headers: {
      'Content-Type': 'application/json'
    }
  }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_parent_info(){
  let data
  await authRequest.get(
    '/children/parent_data'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}